import React, {Component} from "react"
import { Link } from "react-router-dom"
import moment from 'moment';
import localization from 'moment/locale/nl';

import Label from "../../../components/global/Label/Label"
import Title from "../../../components/global/Title/Title"

export default class InitiativesCard extends Component {
  render() {
    return(
      <div className="relative rounded-lg overflow-hidden flex w-full group">
        <div className="p-12 relative z-10 w-full h-60 lg:h-68">
          <div className="absolute bottom-0 pb-8 left-0 right-0 px-8 z-10 block w-full">
            <Label>{moment(this.props.label).locale('nl', localization).format('LL')}</Label>
            <Title className="text-white truncate mt-2 w-full" level="3">{this.props.title}</Title>
            <div className="ease-in-out duration-500 text-white max-h-0 group-hover:max-h-20 group-hover:opacity-100 opacity-0 relative overflow-hidden tracking-wider uppercase text-xs">
              Bekijk initiatief
            </div>
          </div>
          <div className="absolute inset-0 bg-gradient-t-black transform rotate-180 opacity-50 group-hover:opacity-75 ease-in-out duration-500"></div>
          <Link className="absolute inset-0 z-20" to={this.props.link}/>
        </div>
        <div className="inset-0 object-cover object-fill">
          <img style={{ transition: 'opacity 300ms ease 0s' }} className="absolute inset-0 w-full	h-full object-cover object-center opacity-100" src={this.props.imageSrc} alt="alt"/>
        </div>
      </div>
    )
  }
}
